module.exports = __webpack_public_path__ + "media/images/icons/edit-plus-3b3ec26ddaf35accfe1a022104f7430d.png";